import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';

import { Link } from '@confluence/route-manager';
import { SPACE_OVERVIEW } from '@confluence/named-routes';

import type { SpaceAccessDetailsQuery as SpaceAccessDetailsQueryType } from './__types__/SpaceAccessDetailsQuery';

type SpaceDescriptionProps = {
	spaceInfo?: SpaceAccessDetailsQueryType;
	isLoading: boolean;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpaceDescriptionContainer = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	alignItems: 'center',
	flexDirection: 'row',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpaceDescriptionLabel = styled.div({
	paddingLeft: token('space.100'),
	display: 'inline-block',
	color: token('color.text'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'a[data-testid="space-overview-link"]': {
		color: token('color.text'),
		textDecoration: 'underline',
	},
});

export const SpaceDescription: FC<SpaceDescriptionProps> = ({ spaceInfo, isLoading }) => {
	const spaceKey = spaceInfo?.space?.key;
	const spaceUrl = spaceKey ? SPACE_OVERVIEW.toUrl({ spaceKey }) : '';
	return (
		<SpaceDescriptionContainer>
			{!isLoading && (
				<Avatar
					src={
						spaceInfo?.space?.type !== 'personal'
							? spaceInfo?.space?.icon?.path
							: require('../images/personal_space.png')
					}
					size="xsmall"
					appearance="square"
				/>
			)}
			<SpaceDescriptionLabel>
				<Link to={spaceUrl} target="_blank" testId="space-overview-link">
					{spaceInfo?.space?.name}
				</Link>
			</SpaceDescriptionLabel>
		</SpaceDescriptionContainer>
	);
};
